import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { HeadCell } from '../styled/TableHead';

const TableHeadCell = ({
  content,
  inlineStyles,
  testId,
  isRanking,
  innerRef,
  isSortable,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(HeadCell, _extends({
    style: inlineStyles,
    "data-testid": testId && `${testId}--head--cell`,
    ref: typeof innerRef !== 'string' ? innerRef : null // string refs must be discarded as LegacyRefs are not compatible with FC forwardRefs

  }, rest, {
    tabIndex: isSortable ? 0 : undefined,
    isSortable: isSortable
  }), /*#__PURE__*/React.createElement("span", null, content));
};

export default TableHeadCell;